
import { defineComponent, PropType } from 'vue'
import { MetricType } from '~/types/metric'
import { Maybe, Metric, MetricNamespace, MetricNamespaceTrend } from '~/types/types'

export default defineComponent({
  name: 'EditThresholdModal',
  props: {
    thresholdValue: {
      type: [Number, String] as PropType<
        | MetricNamespace['threshold']
        | MetricNamespaceTrend['newCodeThreshold']
        | MetricNamespaceTrend['threshold']
        | undefined
      >
    },
    metricName: {
      type: String as PropType<Metric['name']>,
      required: true
    },
    analyzerKey: {
      type: String as PropType<MetricNamespace['key'] | MetricNamespaceTrend['key']>,
      required: true
    },
    metricShortcode: {
      type: String as PropType<Metric['shortcode']>,
      required: true
    },
    unit: {
      type: String as PropType<Metric['unit'] | Maybe<string> | undefined>,
      required: true
    },
    thresholdName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newThresholdValue: undefined as number | undefined,
      thresholdInputError: false
    }
  },
  computed: {
    isValueAPercentage(): boolean {
      return Boolean(this.unit)
    },
    isAggregate(): boolean {
      return this.analyzerKey === MetricType.aggregate
    }
  },
  watch: {
    metricName() {
      this.resetErrorState()
    },
    analyzerKey() {
      this.resetErrorState()
    },
    '$route.params.metric': {
      handler() {
        this.fullReset()
      }
    }
  },
  methods: {
    validateThreshold(value?: string): void {
      this.thresholdInputError = value
        ? Number(value) < 0 ||
          !Number.isInteger(Number(value)) ||
          (this.isValueAPercentage ? Number(value) > 100 : false)
        : true
    },
    setThresholdValue(input: string): void {
      this.thresholdInputError = false
      this.newThresholdValue = Number(input)
    },
    updateThreshold(close?: () => void): void {
      if (!this.thresholdInputError) {
        if (close && this.newThresholdValue === undefined) {
          close()
          return
        }

        this.$emit(
          'editThreshold',
          Math.round(Number(this.newThresholdValue)),
          this.analyzerKey,
          this.metricShortcode,
          close
        )
      } else {
        this.$toast.danger('Please enter a valid threshold value.')
      }
      return
    },
    resetErrorState(): void {
      this.thresholdInputError = false
    },
    fullReset(): void {
      this.newThresholdValue = undefined
      this.thresholdInputError = false
    }
  }
})
